import { render, staticRenderFns } from "./ExternalLinks.vue?vue&type=template&id=38f4f66d&scoped=true&"
import script from "./ExternalLinks.vue?vue&type=script&lang=js&"
export * from "./ExternalLinks.vue?vue&type=script&lang=js&"
import style0 from "./ExternalLinks.vue?vue&type=style&index=0&id=38f4f66d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f4f66d",
  null
  
)

export default component.exports